// extracted by mini-css-extract-plugin
module.exports = {"myProj":"MyProjects_myProj__2_uTj"};